import React from 'react';
import * as S from './style';

function ToggleSwitch({ id, checked, disabled, onChange, children }) {
  return (
    <S.Container htmlFor={id}>
      <S.ToggleSwitch disabled={disabled}>
        <input
          id={id}
          type="checkbox"
          checked={checked}
          disabled={disabled}
          onChange={onChange}
        />
        <span className="dot" />
        {children}
      </S.ToggleSwitch>
    </S.Container>
  );
}

export default ToggleSwitch;
